<template>
  <div class="hostReport">
    <div class="hostReport__title">
      <h2 class="medium-title">
        Revenue Report
      </h2>
    </div>
      <div class="hostReport__header">
        <div v-if="isLoading">
           <adx-loading-secondary slot="loading" />
        </div>
        <div v-else class="hostReport__header__left">
          <div>{{ totalRevenue | formatMoney}}</div>
          <p>Your revenue on {{ displaySelectedDate }}</p>
        </div>
        <div class="hostReport__header__right">
          <adx-dropdown-list
            :labelButton="displaySelectedDate? displaySelectedDate: firstLabelMonth"
            :list="monthList"
            @selected="selectMonth" />
          <div>
            <button class='btn-download' @click.stop="downloadUrl()">
              Download
              <adx-loading-secondary v-if="downloadLoading" slot="loading" />
            </button>
          </div>
        </div>
      </div>
    <template v-if="!isLoading">
      <div v-if="!dataIsEmpty" class="hostReport__listing">
        <table>
          <thead>
            <tr>
              <td class="header-location">LOCATION</td>
              <td class="header-placement">PLACEMENT</td>
              <td class="header-revenue">REVENUE</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="device in devices" :key="device.id">
              <td class="body location">{{ device.location_name }}</td>
              <td class="body">{{ device.placement }}</td>
              <td class="body">{{ device.host_payable | formatMoney}}</td>
            </tr>
          </tbody>
        </table>
        <div>
          <adx-pagination
            :selectedPage="selectedPage"
            :maxPage="maxPage"
            @change-page="changePage" />
        </div>
      </div>
      <div v-else class="emptyState">
        <adx-empty-selection />
      </div>
    </template>
    <div v-if="isLoading" class="loadingState">
      <adx-loading slot="loading" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import FileSaver from 'file-saver';

import SideBar from '@/components/SideBar/Desktop'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import LoadingSpinner from '@/components/Loading/Secondary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { baseUri } from '@/lib/config'
import { formatShortMonthYear } from '@/lib/util'

export default {
  name: 'adx-host-report',
  components: {
    'adx-sidebar': SideBar,
    'adx-dropdown-list': ListDropdown,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-loading-secondary': LoadingSpinner,
  },
  props: {

  },
  data() {
    return {
      isLoading: false,
      selectedPage: 1,
      maxPage: 1,
      selectedDate: moment(),
      displaySelectedDate: '',
      firstLabelMonth: null,
      firstValueMonth: null,
      monthList: [],
      devices: [],
      totalRevenue: 0,
      downloadLoading: false
    }
  },
  computed: {
    dataIsEmpty() {
      if (this.devices.length > 0) {
        return false
      }

      return true
    },
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.setListMonth()
    let selectedDate = moment().subtract(1, 'month')
    this.selectedDate = selectedDate
    this.displaySelectedDate = formatShortMonthYear(selectedDate)
    this.getRevenues()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getRevenues() {
      (async() => {
        this.isLoading = true
        let data = {
          // month + 1, because month on js start from 0
          // but in python month start from 1
          month: this.selectedDate.month() + 1,
          year: this.selectedDate.year(),
          page: this.selectedPage
        }
        let response = await api.get(apiV2.dashboardHostRevenues, { params: data, needToken: true })
        if (response.status == 200) {
          let data = response.data
          this.devices = data.results
          this.maxPage = data.max_page
          this.totalRevenue = data.total_payable
          this.isLoading = false
        }
      })();
    },
    setListMonth() {
      let maxMonth = 5
      for (let i=1; i<=maxMonth; i++) {
        let earlierMonth = moment().subtract(i, 'month')
        let month = earlierMonth.format('MMM')
        let year = earlierMonth.format('YYYY')
        this.monthList.push({
          id: i,
          label: `${month} ${year}`,
          value: earlierMonth
        })
        this.firstLabelMonth = this.monthList[0].label
        this.firstValueMonth = this.monthList[0].value
      }
    },
    selectMonth(item) {
      this.displaySelectedDate = item.label? item.label:this.firstLabelMonth
      this.selectedDate = item.value?item.value:this.firstValueMonth
      this.getRevenues()
    },
    downloadUrl() {
      (async() => {
        this.downloadLoading = true
        const response = await api.get(
          apiV2.revenueReport(this.selectedDate.month() + 1, this.selectedDate.year()),
          { needToken: true, responseType: 'blob' })
        if (response.status == 200) {
          const month = this.selectedDate.format('MMMM')
          const fileName = `revenue-report-${month}-${this.selectedDate.year()}.xlsx`
          await FileSaver.saveAs(response.data, fileName);
          this.downloadLoading = false
        } else {
          let error = 'Bad Request'
          if (response.status === 403) error = 'Forbidden'
          if (response.status === 500) error = 'Internal Server Error'
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: error,
            type: 'danger'
          });
        }
      })();
    },
    changePage(page) {
      this.selectedPage = page
      this.getRevenues()
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>